if (!customElements.get('dut-product-anchor')) {
  customElements.define('dut-product-anchor', class extends HTMLElement {
    connectedCallback() {
      this.onDetailsClick = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href]');
        if (!link || link.origin !== location.origin || link.pathname !== location.pathname || !link.hash) return;
        const anchorTarget = document.getElementById(link.hash.slice(1));
        if (!anchorTarget) return;
        // Include the review section heading, not only the app widget beneath it.
        const target = anchorTarget.closest('.dut-product-reviews')?.querySelector('.dut-product-reviews__inner') || anchorTarget;
        event.preventDefault();
        this.stopNewsletterGuard?.();
        this.stopNewsletterGuard = this.guardNewsletterDuringScroll(target);
        // Update the shareable anchor without triggering the browser's instant jump.
        if (location.hash !== link.hash) history.pushState(null, '', link.hash);
        target.focus({ preventScroll: true });
        window.dutScrollTo(target, link.hash);
      };
      this.addEventListener('click', this.onDetailsClick);
    }
    guardNewsletterDuringScroll(target) {
      const contentSelector = '.react-responsive-modal-root .ecomsend__Modal__Content';
      const isVisible = (element) => element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
      const existing = new Set([...document.querySelectorAll(contentSelector)].filter(isVisible).map((element) => element.closest('.react-responsive-modal-root')));
      const dismissed = new Map();
      let stopped = false;
      let focusFrame = 0;
      let timeout;
      const restoreTargetFocus = () => {
        const active = document.activeElement;
        if (target.isConnected && (active === document.body || active === target || [...dismissed.keys()].some((root) => root.contains(active)))) {
          target.focus({ preventScroll: true });
        }
      };
      const stop = () => {
        if (stopped) return;
        stopped = true;
        observer.disconnect();
        clearTimeout(timeout);
        cancelAnimationFrame(focusFrame);
        for (const eventName of ['wheel', 'touchstart', 'pointerdown', 'keydown']) document.removeEventListener(eventName, stop, true);
        for (const [root, previous] of dismissed) {
          if (root.isConnected && root.style.getPropertyValue('visibility') === 'hidden') {
            if (previous.value) root.style.setProperty('visibility', previous.value, previous.priority);
            else root.style.removeProperty('visibility');
          }
        }
        if (dismissed.size) restoreTargetFocus();
        dismissed.clear();
        existing.clear();
      };
      const inspect = () => {
        if (stopped) return;
        for (const content of document.querySelectorAll(contentSelector)) {
          const root = content.closest('.react-responsive-modal-root');
          if (existing.has(root) || dismissed.has(root) || !isVisible(content)) continue;
          const close = root.querySelector('button.ecomsend__Modal__CloseButton');
          if (!close || close.disabled) continue;
          // Let the app dismiss its own dialog and clean up focus/scroll state.
          // Conceal only this newly triggered popup before the next paint.
          dismissed.set(root, { value: root.style.getPropertyValue('visibility'), priority: root.style.getPropertyPriority('visibility') });
          root.style.setProperty('visibility', 'hidden', 'important');
          close.click();
        }
        if (dismissed.size && [...dismissed.keys()].every((root) => !root.isConnected)) {
          cancelAnimationFrame(focusFrame);
          focusFrame = requestAnimationFrame(restoreTargetFocus);
        }
      };
      const observer = new MutationObserver(inspect);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      for (const eventName of ['wheel', 'touchstart', 'pointerdown', 'keydown']) document.addEventListener(eventName, stop, { capture: true, passive: true });
      // This is a short explicit-navigation guard, not a change to popup targeting.
      timeout = setTimeout(stop, 3000);
      return stop;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onDetailsClick);
      this.stopNewsletterGuard?.();
    }
  });
}

// Keep older shared review links aligned with the full section heading.
if (location.hash === '#judgeme_product_reviews') {
  const reviews = document.getElementById('product-reviews');
  if (reviews) {
    history.replaceState(history.state, '', '#product-reviews');
    requestAnimationFrame(() => {
      reviews.focus({ preventScroll: true });
      window.dutScrollTo(reviews);
    });
  }
}

if (!customElements.get('dut-gallery-dots')) {
 customElements.define('dut-gallery-dots', class extends HTMLElement {
  connectedCallback() {
   this.gallery = this.closest('media-gallery');
   this.list = this.gallery.querySelector('.product__media-list');
   this.mobile = matchMedia('(max-width:749px)');
   this.position = slide => slide.offsetLeft - this.list.firstElementChild.offsetLeft;
   this.update = () => {
    const visible = [...this.list.children].filter(e => e.offsetWidth > 0);
    if (!visible.length) return;
    const nearest = visible.reduce((a,b) => Math.abs(this.position(a)-this.list.scrollLeft) < Math.abs(this.position(b)-this.list.scrollLeft) ? a : b);
    const index = nearest.hasAttribute('data-dut-loop-index') ? Number(nearest.dataset.dutLoopIndex) : this.slides.indexOf(nearest);
    [...this.children].forEach((button,i) => button.setAttribute('aria-current', String(i===index)));
   };
   this.settle = () => {
    if (!this.loop || this.dragging) return;
    const first = this.position(this.slides[0]);
    const cycle = this.position(this.list.querySelector('[data-dut-loop-end]')) - first;
    const left = this.list.scrollLeft;
    // Preserve the fractional slide offset while returning to the middle cycle.
    if (left < first - 1 || left >= first + cycle - 1) {
     const offset = ((left - first) % cycle + cycle) % cycle;
     this.list.scrollTo({left:first + offset,behavior:'instant'});
    }
    this.update();
   };
   this.onScroll = () => { this.update(); clearTimeout(this.timer); this.timer=setTimeout(this.settle,160); };
   this.rebuild = () => {
    this.mutations?.disconnect();
    this.list.querySelectorAll('[data-dut-loop-index]').forEach(e=>e.remove());
    this.slides=[...this.list.children].filter(e=>e.offsetWidth>0);
    this.loop=this.mobile.matches && this.slides.length>1 && this.slides.every(e=>e.querySelector('.product__modal-opener--image'));
    const clone = (slide,index,end=false) => {
     const copy=slide.cloneNode(true);
     copy.dataset.dutLoopIndex=index;
     if(end) copy.dataset.dutLoopEnd='';
     copy.setAttribute('aria-hidden','true');
     [copy,...copy.querySelectorAll('[id]')].forEach(e=>e.removeAttribute('id'));
     copy.removeAttribute('data-media-id');
     copy.querySelectorAll('button,a,input,[tabindex]').forEach(e=>e.setAttribute('tabindex','-1'));
     copy.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();slide.querySelector('.product__media-toggle')?.click();},true);
     return copy;
    };
    if(this.loop){
     // Two complete cycles on either side leave room for fast native swipes.
     this.list.prepend(...[0,1].flatMap(()=>this.slides.map((slide,i)=>clone(slide,i))));
     this.list.append(...[0,1].flatMap((cycle)=>this.slides.map((slide,i)=>clone(slide,i,cycle===0 && i===0))));
    }
    this.list.classList.toggle('dut-gallery-loop',this.loop);
    this.replaceChildren(...this.slides.map((slide,i)=>{
     const button=document.createElement('button');button.type='button';
     button.setAttribute('aria-label',`View product media ${i+1} of ${this.slides.length}`);
     button.addEventListener('click',()=>this.list.scrollTo({left:this.position(slide),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
     return button;
    }));
    this.hidden=this.slides.length<2;
    if(this.slides.length) this.list.scrollTo({left:this.position(this.slides[0]),behavior:'instant'});
    this.update();
    this.mutations.observe(this.list,{childList:true});
   };
   this.mutations=new MutationObserver(this.rebuild);
   // Recenter before the next gesture, even if the previous swipe never settled.
   this.onDown=()=>{clearTimeout(this.timer);this.dragging=false;this.settle();this.dragging=true;};
   this.onUp=()=>{this.dragging=false;clearTimeout(this.timer);this.timer=setTimeout(this.settle,160);};
   this.list.addEventListener('scroll',this.onScroll,{passive:true});
   this.list.addEventListener('pointerdown',this.onDown,{passive:true});
   this.list.addEventListener('scrollend',this.settle,{passive:true});
   window.addEventListener('pointerup',this.onUp,{passive:true});
   window.addEventListener('pointercancel',this.onUp,{passive:true});
   this.mobile.addEventListener('change',this.rebuild);
   this.resize=new ResizeObserver(()=>{const w=this.list.clientWidth;if(w!==this.width){this.width=w;this.rebuild();}});this.resize.observe(this.list);
   this.rebuild();
  }
  disconnectedCallback(){
   clearTimeout(this.timer);this.list?.removeEventListener('scroll',this.onScroll);this.list?.removeEventListener('pointerdown',this.onDown);this.list?.removeEventListener('scrollend',this.settle);
   window.removeEventListener('pointerup',this.onUp);window.removeEventListener('pointercancel',this.onUp);this.mobile?.removeEventListener('change',this.rebuild);this.resize?.disconnect();this.mutations?.disconnect();
   this.list?.querySelectorAll('[data-dut-loop-index]').forEach(e=>e.remove());
  }
 });
}
